/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContactType } from '@gh/builder-shared-data';
import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';

import { EnumDictionary, FormState, FormStateBuilder, getDialogInitData } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import { getControlValue } from '@gh/core-ui';

import { assign } from 'lodash';

import {
  ContactFinderBusinessService,
  ContactFinderDialogConfig,
} from '../../resources/contact-finder-business.service';
import {
  ContactFinderListItem,
  getContactFinderListItemId,
} from '../../resources/contact-finder-list-item.model';
import { ContactFinderGridDefinition } from './contact-finder-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-contact-finder-dialog',
  templateUrl: 'contact-finder-dialog.component.html',
  styleUrls: ['contact-finder-dialog.component.scss'],
  providers: [ContactFinderGridDefinition],
})
export class ContactFinderDialogComponent
  extends AbstractFinderDialogComponent<ContactFinderDialogConfig, ContactFinderListItem>
  implements OnInit {

  getId = getContactFinderListItemId;

  form: FormState<any>;
  contactTypes: EnumDictionary<ContactType>;
  defaultTitle: string;

  constructor(formStateBuilder: FormStateBuilder,
              private translations: TranslationService,
              @Inject(MAT_DIALOG_DATA) private dialogData: any,
              public gridDefinition: ContactFinderGridDefinition,
              private dialogRef: MatDialogRef<any>,
              private businessService: ContactFinderBusinessService) {
    super(dialogRef);

    this.form = formStateBuilder.buildPlain({
      children: {
        name: void 0,
      },
    });
  }

  get contactType(): ContactType {
    return this.input.type;
  }

  ngOnInit(): void {
    assign(this, getDialogInitData(this.dialogData));

    super.ngOnInit();

    this.defaultTitle = `${this.translations.get('lbl_find')} ${this.contactTypes.get(this.contactType)}`;
  }

  protected buildDataSource(): SlicedDataSource<ContactFinderListItem> {
    const name = getControlValue(this.form.group, 'name');

    return this.businessService.findAllAsDataSource([this.input.type], name, this.input.withAddress);
  }
}
